import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

function QRCode({ data, value, style, size = 256 }) {
	return <QRCodeSVG value={value || data} style={style} size={size}/>;
}

QRCode.type = 'QRCode';

export default QRCode;